<template>
  <div v-if="factors.length" class="card main-info">
    <div class="card-body">
      <h5 class="card-title">Налоги и сборы</h5>
      <ul class="info-list mt-3">
        <li
          v-for="factor in factors"
          :key="factor.id"
          class="flex flex-row justify-content-between align-items-center border-bottom mt-2"
        >
          <span class="info-value success w-auto">{{ factor.title }}</span
          ><span class="info-bold">{{ factor.text }}</span>
          <span class="info-percent" :class="getPercentClass(factor.percent)">
            {{ factor.percent }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";

export default defineComponent({
  name: "TaxesInfo",
  props: {
    html: String,
  },
  setup(props) {
    const factors = ref([]);

    const getPercentClass = (percent) => {
      if (!percent) return "";
      if (percent.includes("+")) return "is-positive";
      if (percent.includes("-")) return "is-negative";
      return "";
    };

    const getParsing = () => {
      if (!props.html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(props.html, "text/html");

      const taxes = doc.getElementById("taxes");
      const rows = taxes?.querySelectorAll(".bs-row > div");

      if (!rows?.length) return;

      rows.forEach((row, index) => {
        const rowTitle = row.querySelector(".fw-700");
        const rowValue = row.querySelector(".text-huge a");
        const rowPercent = row.querySelector(".text-huge small");

        const title = rowTitle?.textContent?.trim();
        const value = rowValue.textContent
          .replace(rowPercent?.textContent || "", "")
          .trim();

        if (!title || !value) return;

        factors.value.push({
          id: index + 1,
          title,
          text: value,
          percent: rowPercent?.textContent?.trim() || "",
        });
      });
    };

    const hydrate = () => {
      if (!props.html) {
        factors.value = [];
        return;
      }
      factors.value = [];
      getParsing();
    };

    onMounted(hydrate);
    watch(() => props.html, hydrate);
    return {
      factors,
      getPercentClass,
    };
  },
});
</script>
